import { render } from "./ModalSelectItem.vue?vue&type=template&id=5b28906a&scoped=true"
import script from "./ModalSelectItem.vue?vue&type=script&lang=js"
export * from "./ModalSelectItem.vue?vue&type=script&lang=js"

import "./ModalSelectItem.vue?vue&type=style&index=0&id=5b28906a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b28906a"]])

export default __exports__